import React from 'react';
import logoColor from '../assets/CentralHealth_SecondaryLogo_Horiz_FullColor_RGB.png';
import logoWhite from '../assets/logo-large-white.png';
import markColor from '../assets/centralhealth-mark.png';

/**
 * Central Health logo — official brand assets.
 * (Component keeps its historical `SenderoLogo` name so existing imports —
 * login, sidebar, register/forgot pages — keep working unchanged.)
 *
 * Variants:
 *  - "full"      mark + wordmark (default)
 *  - "mark"      circular split-teal/mint mark only
 *
 * Props:
 *  - `height`   rendered height in px (width derives automatically from aspect ratio)
 *  - `mono`     "white" renders the all-white version for dark backgrounds
 *  - `color`    legacy alias — pass "#fff" / "white" to get the white variant
 *  - `title`    accessible label (default "Central Health")
 */
const SenderoLogo = ({
  height = 32,
  variant = 'full',
  mono,
  color,
  style,
  title = 'Central Health',
}) => {
  const isWhite = mono === 'white' || color === '#fff' || color === 'white';
  const isMark = variant === 'mark';

  // No white standalone-mark asset exists; the white full logo is the fallback.
  let src;
  if (isMark) {
    src = isWhite ? logoWhite : markColor;
  } else {
    src = isWhite ? logoWhite : logoColor;
  }

  return (
    <img
      src={src}
      alt={title}
      style={{ height, width: 'auto', display: 'block', flexShrink: 0, ...style }}
    />
  );
};

export default SenderoLogo;
